module.exports = __webpack_public_path__ + "us.411950a3fa8921c24b23.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/us.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/us.svg
// module chunks = styles